import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { VadenJS } from "../../shared/utilty/js-actions/VadenJS";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IArama_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IArama_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetLanguage: string;
  GetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetYeniUrunler: any[];
  GetYeniUrunler_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetStokAra: any[];
  GetStokAra_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  GetMarka: any[];
  GetMarka_dummy: any[];
  GetMotor: any[];
  GetMotor_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetGrupTanim: any[];
  GetGrupTanim_dummy: any[];
  ClearSearchParameter: any;
  ClearSearchParameter_dummy: any;
  GetStokKategorileriBul: any[];
  GetStokKategorileriBul_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetModel: any[];
  GetModel_dummy: any[];
  InsertAramaLogu: number;
  InsertAramaLogu_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  ScrollTo: string;
  ScrollTo_dummy: string;
  isComp569640Visible: "visible" | "hidden";
  isComp811930Visible: "visible" | "hidden";
  isComp837880Visible: "visible" | "hidden";
  isComp162078Visible: "visible" | "hidden";
  isComp553008Visible: "visible" | "hidden";
  isComp973876Visible: "visible" | "hidden";
  isComp865868Visible: "visible" | "hidden";
  isComp625553Visible: "visible" | "hidden";
  isComp573062Visible: "visible" | "hidden";
}

export class Arama_ScreenBase extends React.PureComponent<
  IArama_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  arama_801710_value_kuikaTreeRef: React.RefObject<any>;
  arama_617415_value_kuikaAutoCompleteRef: React.RefObject<any>;
  arama_797098_value_kuikaAutoCompleteRef: React.RefObject<any>;
  arama_851968_value_kuikaAutoCompleteRef: React.RefObject<any>;
  arama_190352_value_kuikaFlexGridRef: React.RefObject<any>;
  arama_424842_value_kuikaCarouselRef: React.RefObject<any>;
  arama_973052_value_kuikaGalleryViewRef: React.RefObject<any>;
  arama_625553_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 713445,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 148062,
          PropertyName: "value",
          Value: "CATEGORIES",
          TagName: "Label17_1_value",
        },
        {
          Id: 697509,
          PropertyName: "value",
          Value: "YOU CAN SELECT A PRODUCT CATEGORY",
          TagName: "Label21_value",
        },
        {
          Id: 375763,
          PropertyName: "placeholder",
          Value: "SEARCH",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 424842,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
          TagName: "Carousel1_nodatafoundmessage",
        },
        {
          Id: 425289,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 996224,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 294160,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 759768,
          PropertyName: "value",
          Value: "PRODUCT SEARCH",
          TagName: "Label17_0_value",
        },
        {
          Id: 342709,
          PropertyName: "value",
          Value: "YOU CAN SEARCH BY BRAND, MODEL AND ENGINE TYPE",
          TagName: "Label20_value",
        },
        {
          Id: 166230,
          PropertyName: "value",
          Value: "CLEAR",
          TagName: "Label14_value",
        },
        {
          Id: 617415,
          PropertyName: "placeholder",
          Value: "BRAND",
          TagName: "SelectBox2_placeholder",
        },
        {
          Id: 797098,
          PropertyName: "placeholder",
          Value: "MODEL",
          TagName: "SelectBox3_placeholder",
        },
        {
          Id: 851968,
          PropertyName: "placeholder",
          Value: "ENGINE TYPE",
          TagName: "SelectBox4_placeholder",
        },
        {
          Id: 953081,
          PropertyName: "value",
          Value: "NEW PRODUCTS",
          TagName: "Label4_value",
        },
        {
          Id: 298828,
          PropertyName: "label",
          Value: "Examine the Product",
          TagName: "Button1_label",
        },
        {
          Id: 353388,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 500574,
          PropertyName: "value",
          Value: "VIEW PRODUCT",
          TagName: "Label5_value",
        },
        {
          Id: 8037,
          PropertyName: "value",
          Value: "VIEW PRODUCT",
          TagName: "Label13_value",
        },
        {
          Id: 56089,
          PropertyName: "label",
          Value: "VIEW ",
          TagName: "Button0_label",
        },
        {
          Id: 98628533,
          PropertyName: "0f9e54c9-0dae-a046-210b-7d87a00b36eb_notify",
          Value: "CANNOT ADD A PRODUCT TO YOUR CART WITHOUT A PRICE",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 713445,
          PropertyName: "placeholder",
          Value: "no Vaden, no OEM, nom du produit, marque, modèle, véhicule",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 148062,
          PropertyName: "value",
          Value: "Catégories",
          TagName: "Label17_1_value",
        },
        {
          Id: 697509,
          PropertyName: "value",
          Value: "Vous pouvez sélectionner une catégorie de produits",
          TagName: "Label21_value",
        },
        {
          Id: 375763,
          PropertyName: "placeholder",
          Value: "Recherche...",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 424842,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
          TagName: "Carousel1_nodatafoundmessage",
        },
        {
          Id: 425289,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 996224,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 294160,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 759768,
          PropertyName: "value",
          Value: "Recherche de produits",
          TagName: "Label17_0_value",
        },
        {
          Id: 342709,
          PropertyName: "value",
          Value:
            "Vous pouvez rechercher des produits en sélectionnant la marque, le modèle et le moteur.",
          TagName: "Label20_value",
        },
        {
          Id: 166230,
          PropertyName: "value",
          Value: "Clair",
          TagName: "Label14_value",
        },
        {
          Id: 617415,
          PropertyName: "placeholder",
          Value: "Marque",
          TagName: "SelectBox2_placeholder",
        },
        {
          Id: 797098,
          PropertyName: "placeholder",
          Value: "Modèle",
          TagName: "SelectBox3_placeholder",
        },
        {
          Id: 851968,
          PropertyName: "placeholder",
          Value: "Moteur",
          TagName: "SelectBox4_placeholder",
        },
        {
          Id: 953081,
          PropertyName: "value",
          Value: "Nouveaux produits",
          TagName: "Label4_value",
        },
        {
          Id: 298828,
          PropertyName: "label",
          Value: "Examiner le produit",
          TagName: "Button1_label",
        },
        {
          Id: 353388,
          PropertyName: "placeholder",
          Value: "no Vaden, no OEM, nom du produit, marque, modèle, véhicule",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 56089,
          PropertyName: "label",
          Value: "Examinez",
          TagName: "Button0_label",
        },
        {
          Id: 32436134,
          PropertyName: "0f9e54c9-0dae-a046-210b-7d87a00b36eb_notify",
          Value:
            "Vous ne pouvez pas ajouter un produit sans prix à votre panier.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 713445,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 148062,
          PropertyName: "value",
          Value: "Categorías",
          TagName: "Label17_1_value",
        },
        {
          Id: 697509,
          PropertyName: "value",
          Value: "Puedes seleccionar una categoría de producto",
          TagName: "Label21_value",
        },
        {
          Id: 375763,
          PropertyName: "placeholder",
          Value: "Buscar...",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 424842,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
          TagName: "Carousel1_nodatafoundmessage",
        },
        {
          Id: 425289,
          PropertyName: "label",
          Value: "Turkish",
          TagName: "ContentMenuItem4_2_label",
        },
        {
          Id: 996224,
          PropertyName: "label",
          Value: "English",
          TagName: "ContentMenuItem4_3_label",
        },
        {
          Id: 294160,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 759768,
          PropertyName: "value",
          Value: "Buscar productos",
          TagName: "Label17_0_value",
        },
        {
          Id: 342709,
          PropertyName: "value",
          Value: "Buscar productos por marca, modelo y motor",
          TagName: "Label20_value",
        },
        {
          Id: 166230,
          PropertyName: "value",
          Value: "Claro",
          TagName: "Label14_value",
        },
        {
          Id: 617415,
          PropertyName: "placeholder",
          Value: "Marca",
          TagName: "SelectBox2_placeholder",
        },
        {
          Id: 797098,
          PropertyName: "placeholder",
          Value: "Modelo",
          TagName: "SelectBox3_placeholder",
        },
        {
          Id: 851968,
          PropertyName: "placeholder",
          Value: "Motor",
          TagName: "SelectBox4_placeholder",
        },
        {
          Id: 953081,
          PropertyName: "value",
          Value: "Nuevos productos",
          TagName: "Label4_value",
        },
        {
          Id: 298828,
          PropertyName: "label",
          Value: "Ver producto",
          TagName: "Button1_label",
        },
        {
          Id: 353388,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, nombre del producto, marca, modelo, vehículo",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 56089,
          PropertyName: "label",
          Value: "Ver",
          TagName: "Button0_label",
        },
        {
          Id: 33227029,
          PropertyName: "0f9e54c9-0dae-a046-210b-7d87a00b36eb_notify",
          Value: "No se puede añadir un producto al carrito sin el precio.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "37020e50-b14f-42b4-89d7-19636aec279c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 713445,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 425289, PropertyName: "label", Value: "Turkish" },
        { Id: 996224, PropertyName: "label", Value: "English" },
        { Id: 620307, PropertyName: "label", Value: "Spanish" },
        { Id: 950178, PropertyName: "label", Value: "French" },
        { Id: 294160, PropertyName: "label", Value: "Profil" },
        { Id: 148062, PropertyName: "value", Value: "Kategoriler" },
        {
          Id: 697509,
          PropertyName: "value",
          Value: "Ürün Kategorisi Seçebilirsiniz",
        },
        { Id: 375763, PropertyName: "placeholder", Value: "Ara..." },
        { Id: 633438, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 759768, PropertyName: "value", Value: "Ürün Arama" },
        {
          Id: 342709,
          PropertyName: "value",
          Value: "Marka, Model, Motor Seçerek Ürünleri Arayabilirsiniz",
        },
        { Id: 445474, PropertyName: "label", Value: "Geri" },
        { Id: 617415, PropertyName: "placeholder", Value: " Marka" },
        { Id: 797098, PropertyName: "placeholder", Value: "Model" },
        { Id: 851968, PropertyName: "placeholder", Value: "Motor" },
        {
          Id: 353388,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 166230, PropertyName: "value", Value: "Temizle" },
        {
          Id: 190352,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 146585, PropertyName: "value", Value: "[datafield:grup_adi]" },
        {
          Id: 424842,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 953081, PropertyName: "value", Value: "Yeni Ürünler" },
        { Id: 500574, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        {
          Id: 771082,
          PropertyName: "value",
          Value: "[datafield:birlesmisstok]",
        },
        { Id: 298828, PropertyName: "label", Value: "Ürünü İncele" },
        {
          Id: 973052,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 538484, PropertyName: "value", Value: "[datafield:fiyat]" },
        {
          Id: 973876,
          PropertyName: "title",
          Value: "[datafield:adetbazlifiyataciklama]",
        },
        { Id: 8037, PropertyName: "value", Value: "[datafield:stok_kodu]" },
        { Id: 474141, PropertyName: "value", Value: "[datafield:stok_adi]" },
        { Id: 56089, PropertyName: "label", Value: "İncele" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.arama_713445_value_kuikaTextInputRef = React.createRef();
    this.arama_375763_value_kuikaTextInputRef = React.createRef();
    this.arama_801710_value_kuikaTreeRef = React.createRef();
    this.arama_633438_value_kuikaTextInputRef = React.createRef();
    this.arama_617415_value_kuikaAutoCompleteRef = React.createRef();
    this.arama_797098_value_kuikaAutoCompleteRef = React.createRef();
    this.arama_851968_value_kuikaAutoCompleteRef = React.createRef();
    this.arama_353388_value_kuikaTextInputRef = React.createRef();
    this.arama_190352_value_kuikaFlexGridRef = React.createRef();
    this.arama_424842_value_kuikaCarouselRef = React.createRef();
    this.arama_973052_value_kuikaGalleryViewRef = React.createRef();
    this.arama_625553_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetLanguage: "",
      GetParametreler: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetYeniUrunler: [],
      IfThenElse: false,
      GetStokAra: [],
      GetCariParaBirimi: [],
      GetMarka: [],
      GetMotor: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetGrupTanim: [],
      ClearSearchParameter: "",
      GetStokKategorileriBul: [],
      SetValueOf: "",
      TriggerEvent: "",
      GetModel: [],
      InsertAramaLogu: 0,
      ScrollTo: "",
      isComp569640Visible: "hidden",
      isComp811930Visible: "hidden",
      isComp837880Visible: "hidden",
      isComp162078Visible: "hidden",
      isComp553008Visible: "hidden",
      isComp973876Visible: "hidden",
      isComp865868Visible: "hidden",
      isComp625553Visible: "visible",
      isComp573062Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("arama", "blank_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.AramaPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.AramaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("arama", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("arama", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AramaPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.AramaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      arama_353388_value:
        this.props.screenInputs.Ara ?? this.props.screenInputs.ara,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AramaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GetLanguage = await ReactSystemFunctions.getLanguage(
      this.ml,
      this.defaultML
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AramaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp569640Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp865868Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.arama_372831_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AramaPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      tip_1: ReactSystemFunctions.convertToTypeByName(0, "number"),
      FiyatGrubu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiyati_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      dil_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetYeniUrunler = result?.data.getYeniUrunler;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaPageInit_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.AramaComponent_353388_onPressEnter()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AramaPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        this.props.screenInputs.Ara ?? this.props.screenInputs.ara,
        true
      )
    ) {
      isErrorOccurred = await this.AramaPageInit_if4();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaPageInit5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AramaPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      dbName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      page_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_625553_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      pagesize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_625553_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      FiyatGrubu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiati_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_353388_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Marka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_617415_value",
            "value",
            "GetMarka",
            "marka",
            "marka"
          )
        ),
        "string"
      ),
      Model_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_797098_value",
            "value",
            "GetModel",
            "model",
            "model"
          )
        ),
        "string"
      ),
      Motor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_851968_value",
            "value",
            "GetMotor",
            "motor",
            "motor"
          )
        ),
        "string"
      ),
      Dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      KategoriInckey_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_633438_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      paraBirimi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      Marka_2: ReactSystemFunctions.convertToTypeByName(null, "string"),
      seciliMotor_3: ReactSystemFunctions.convertToTypeByName(null, "string"),
      FirmaKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      search_6: ReactSystemFunctions.convertToTypeByName("", "string"),
      dil_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      tip_6: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaPageInit5_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStokAra = result?.data.getStokAra;

    stateVars.isComp553008Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp625553Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].totalRecords
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].totalRecords
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp573062Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    stateVars.GetMarka = result?.data.getMarka;

    formVars.arama_617415_options = stateVars.GetMarka;
    stateVars.GetMotor = result?.data.getMotor;

    formVars.arama_851968_options = stateVars.GetMotor;
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.arama_551643_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.arama_530264_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetGrupTanim = result?.data.getGrupTanim;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaPageInit6_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ClearSearchParameter = VadenJS.ClearSearchParameter();
    formVars.arama_551643_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp569640Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.arama_530264_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.arama_372831_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.arama_140817_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.arama_801710_options = ReactSystemFunctions.value(
      this,
      this.state.GetGrupTanim
    );

    stateVars.dataSource_801710 =
      stateVars.GetGrupTanim ?? this.state.GetGrupTanim;
    stateVars.dataSource_801710 =
      stateVars.GetGrupTanim ?? this.state.GetGrupTanim;

    stateVars.dataSource_617415 = stateVars.GetMarka ?? this.state.GetMarka;
    stateVars.dataSource_617415 = stateVars.GetMarka ?? this.state.GetMarka;

    stateVars.dataSource_851968 = stateVars.GetMotor ?? this.state.GetMotor;
    stateVars.dataSource_851968 = stateVars.GetMotor ?? this.state.GetMotor;
    stateVars.isComp837880Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokKategorileriBul !== undefined
            ? stateVars.GetStokKategorileriBul?.length > 0
              ? stateVars.GetStokKategorileriBul[0].inckeyno
              : null
            : this.state.GetStokKategorileriBul?.length > 0
            ? this.state.GetStokKategorileriBul[0].inckeyno
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp162078Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "arama_190352_value", "sonKayit"),
        false
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_424842 =
      stateVars.GetYeniUrunler ?? this.state.GetYeniUrunler;

    stateVars.isComp553008Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_973052 = stateVars.GetStokAra ?? this.state.GetStokAra;
    formVars.arama_305832_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp973876Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "arama_973052_value",
          "adetBazliFiyatVarMi"
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.isComp865868Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    formVars.arama_625553_total = ReactSystemFunctions.value(
      this,
      stateVars.GetStokAra !== undefined
        ? stateVars.GetStokAra?.length > 0
          ? stateVars.GetStokAra[0].totalRecords
          : null
        : this.state.GetStokAra?.length > 0
        ? this.state.GetStokAra[0].totalRecords
        : null
    );

    stateVars.isComp625553Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].totalRecords
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].totalRecords
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp573062Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AramaComponent_713445_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_713445_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_569640_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_938647_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "683754",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_425289_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_996224_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_620307_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_950178_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_294160_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_375763_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_375763_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      tip_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      search_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_375763_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dil_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      tip_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_375763_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetGrupTanim = result?.data.getGrupTanim;
    stateVars.GetGrupTanim = result?.data.getGrupTanim;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_375763_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_375763_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.arama_801710_options = ReactSystemFunctions.value(
      this,
      this.state.GetGrupTanim
    );

    stateVars.dataSource_801710 =
      stateVars.GetGrupTanim ?? this.state.GetGrupTanim;
    stateVars.dataSource_801710 =
      stateVars.GetGrupTanim ?? this.state.GetGrupTanim;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_801710_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InckeyNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_801710_value",
            "value",
            "GetGrupTanim",
            "inckeyno",
            "inckeyno"
          )
        ),
        "number"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_801710_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStokKategorileriBul = result?.data.getStokKategorileriBul;

    stateVars.isComp837880Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokKategorileriBul !== undefined
            ? stateVars.GetStokKategorileriBul?.length > 0
              ? stateVars.GetStokKategorileriBul[0].inckeyno
              : null
            : this.state.GetStokKategorileriBul?.length > 0
            ? this.state.GetStokKategorileriBul[0].inckeyno
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_801710_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_801710_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("arama_633438_value", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "arama_801710_value",
          "value",
          "GetGrupTanim",
          "inckeyno",
          "inckeyno"
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("arama_353388_value", "string"),
      "",
      null,
      false
    );
    if (await this.AramaComponent_581684_onClick()) return true;

    stateVars.dataSource_190352 =
      stateVars.GetStokKategorileriBul ?? this.state.GetStokKategorileriBul;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_801710_onSelect = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      InckeyNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_801710_value",
            "value",
            "GetGrupTanim",
            "inckeyno",
            "inckeyno"
          )
        ),
        "number"
      ),
      dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_801710_onSelect",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStokKategorileriBul = result?.data.getStokKategorileriBul;

    stateVars.isComp837880Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokKategorileriBul !== undefined
            ? stateVars.GetStokKategorileriBul?.length > 0
              ? stateVars.GetStokKategorileriBul[0].inckeyno
              : null
            : this.state.GetStokKategorileriBul?.length > 0
            ? this.state.GetStokKategorileriBul[0].inckeyno
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_801710_onSelect1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_801710_onSelect1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("arama_633438_value", "string"),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "arama_801710_value",
          "value",
          "GetGrupTanim",
          "inckeyno",
          "inckeyno"
        )
      ),
      null,
      false
    );
    if (await this.AramaComponent_581684_onClick()) return true;

    stateVars.dataSource_190352 =
      stateVars.GetStokKategorileriBul ?? this.state.GetStokKategorileriBul;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_445474_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(null, "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_617415_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Model_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      marka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_617415_value",
            "value",
            "GetMarka",
            "marka",
            "marka"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_617415_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetModel = result?.data.getModel;

    formVars.arama_797098_options = stateVars.GetModel;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_617415_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_617415_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.AramaComponent_581684_onClick()) return true;

    stateVars.dataSource_797098 = stateVars.GetModel ?? this.state.GetModel;
    stateVars.dataSource_797098 = stateVars.GetModel ?? this.state.GetModel;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_797098_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      seciliMotor_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_797098_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMotor = result?.data.getMotor;

    formVars.arama_851968_options = stateVars.GetMotor;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_797098_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_797098_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.AramaComponent_581684_onClick()) return true;

    stateVars.dataSource_851968 = stateVars.GetMotor ?? this.state.GetMotor;
    stateVars.dataSource_851968 = stateVars.GetMotor ?? this.state.GetMotor;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_851968_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.AramaComponent_581684_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_353388_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.AramaComponent_581684_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_581684_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dbName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      page_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      pagesize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_625553_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      FiyatGrubu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiati_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_353388_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Marka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_617415_value",
            "value",
            "GetMarka",
            "marka",
            "marka"
          )
        ),
        "string"
      ),
      Model_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_797098_value",
            "value",
            "GetModel",
            "model",
            "model"
          )
        ),
        "string"
      ),
      Motor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_851968_value",
            "value",
            "GetMotor",
            "motor",
            "motor"
          )
        ),
        "string"
      ),
      Dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      KategoriInckey_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_633438_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ArananKelime_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_353388_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Dil_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      isPlasiyer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      ToplamDonenVeri_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].totalRecords
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].totalRecords
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_581684_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStokAra = result?.data.getStokAra;

    stateVars.isComp553008Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp625553Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].totalRecords
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].totalRecords
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp573062Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.InsertAramaLogu = result?.data.insertAramaLogu;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_581684_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_581684_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("arama_625553_value", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_973052 = stateVars.GetStokAra ?? this.state.GetStokAra;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_837880_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dbName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      page_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      pagesize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_625553_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      FiyatGrubu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiati_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_353388_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Marka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_617415_value",
            "value",
            "GetMarka",
            "marka",
            "marka"
          )
        ),
        "string"
      ),
      Model_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_797098_value",
            "value",
            "GetModel",
            "model",
            "model"
          )
        ),
        "string"
      ),
      Motor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_851968_value",
            "value",
            "GetMotor",
            "motor",
            "motor"
          )
        ),
        "string"
      ),
      Dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      KategoriInckey_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      InckeyNo_1: ReactSystemFunctions.convertToTypeByName(null, "number"),
      dil_1: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_837880_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStokAra = result?.data.getStokAra;

    stateVars.isComp553008Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp625553Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].totalRecords
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].totalRecords
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp573062Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetStokKategorileriBul = result?.data.getStokKategorileriBul;

    stateVars.isComp837880Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokKategorileriBul !== undefined
            ? stateVars.GetStokKategorileriBul?.length > 0
              ? stateVars.GetStokKategorileriBul[0].inckeyno
              : null
            : this.state.GetStokKategorileriBul?.length > 0
            ? this.state.GetStokKategorileriBul[0].inckeyno
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_837880_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_837880_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("arama_633438_value", "string"),
      null,
      null,
      false
    );

    stateVars.dataSource_190352 =
      stateVars.GetStokKategorileriBul ?? this.state.GetStokKategorileriBul;

    stateVars.dataSource_973052 = stateVars.GetStokAra ?? this.state.GetStokAra;
    formVars.arama_625553_total = ReactSystemFunctions.value(
      this,
      stateVars.GetStokAra !== undefined
        ? stateVars.GetStokAra?.length > 0
          ? stateVars.GetStokAra[0].totalRecords
          : null
        : this.state.GetStokAra?.length > 0
        ? this.state.GetStokAra[0].totalRecords
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_298828_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_424842_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariParaBirimi !== undefined
            ? stateVars.GetCariParaBirimi?.length > 0
              ? stateVars.GetCariParaBirimi[0].paraSembol
              : null
            : this.state.GetCariParaBirimi?.length > 0
            ? this.state.GetCariParaBirimi[0].paraSembol
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_424842_value", "koD_3"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "91839",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_56089_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "listeFiat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "FiatGrup",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariParaBirimi !== undefined
            ? stateVars.GetCariParaBirimi?.length > 0
              ? stateVars.GetCariParaBirimi[0].paraSembol
              : null
            : this.state.GetCariParaBirimi?.length > 0
            ? this.state.GetCariParaBirimi[0].paraSembol
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "Kod3",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "koD_3"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "prooductDetail",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName("", "string")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "prooductDetail",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "237530",
      null,
      "top",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_865868_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "fiyat"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "kdV_ORANI"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "stoK_ADI"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(false, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "175496",
      null,
      null,
      "true",
      "400px",
      "38vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_265716_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "0f9e54c9_0dae_a046_210b_7d87a00b36eb_notify",
        this.defaultML,
        "Fiyatı olmayan ürünü sepete ekleyemezsiniz"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("#212121", "string"),
      ReactSystemFunctions.convertToTypeByName("#ffffff", "string"),
      14
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AramaComponent_265716_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "BirimFiyat",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "fiyat"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "stoK_KODU"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "PlasiyerMi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "KdvOrani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "kdV_ORANI"),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "StokAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "arama_973052_value", "stoK_ADI"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isSiparis",
      ReactSystemFunctions.convertToTypeByName(true, "boolean")
    );
    KuikaAppManager.addToPageInputVariables(
      "SepetModal",
      "isYurtici",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].isYurtici
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].isYurtici
            : null
        ),
        "boolean"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Arama",
      "SepetModal",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "114492",
      null,
      null,
      "True",
      "400px",
      "55vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  AramaComponent_265716_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "arama_973052_value", "fiyat"),
        "0"
      )
    ) {
      isErrorOccurred = await this.AramaComponent_265716_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.AramaComponent_265716_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_625553_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dbName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      page_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_625553_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      pagesize_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_625553_value",
            "pageSize",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      FiyatGrubu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].fiyatgrubu
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].fiyatgrubu
            : null
        ),
        "string"
      ),
      CariKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      ListeFiati_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].listE_FIATI
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].listE_FIATI
            : null
        ),
        "string"
      ),
      Ara_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_353388_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Marka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_617415_value",
            "value",
            "GetMarka",
            "marka",
            "marka"
          )
        ),
        "string"
      ),
      Model_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_797098_value",
            "value",
            "GetModel",
            "model",
            "model"
          )
        ),
        "string"
      ),
      Motor_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_851968_value",
            "value",
            "GetMotor",
            "motor",
            "motor"
          )
        ),
        "string"
      ),
      Dil_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.GetLanguage),
        "string"
      ),
      KategoriInckey_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "arama_633438_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Arama/AramaComponent_625553_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStokAra = result?.data.getStokAra;

    stateVars.isComp553008Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp625553Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].totalRecords
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].totalRecords
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp573062Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStokAra !== undefined
            ? stateVars.GetStokAra?.length > 0
              ? stateVars.GetStokAra[0].subE_KODU
              : null
            : this.state.GetStokAra?.length > 0
            ? this.state.GetStokAra[0].subE_KODU
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AramaComponent_625553_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AramaComponent_625553_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ScrollTo = await ReactSystemFunctions.scrollTo(
      ReactSystemFunctions.convertToTypeByName("796116", "string")
    );

    stateVars.dataSource_973052 = stateVars.GetStokAra ?? this.state.GetStokAra;
    formVars.arama_625553_total = ReactSystemFunctions.value(
      this,
      stateVars.GetStokAra !== undefined
        ? stateVars.GetStokAra?.length > 0
          ? stateVars.GetStokAra[0].totalRecords
          : null
        : this.state.GetStokAra?.length > 0
        ? this.state.GetStokAra[0].totalRecords
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_771082_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AramaComponent_474141_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      683754,
      ,
      ,
      91839,
      237530,
      175496,
      114492,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AramaPageInit();
    }
  }
}
